import type { ClassificationResult } from '@classification-testing/domain';
import type { DomainError } from '@core/domain';
import { createAction } from '@reduxjs/toolkit';

/**
 * Action types with domain prefix
 */
export const SET_CLASSIFICATION_LOADING = 'classification/setLoading';
export const SET_CLASSIFICATION_ERROR = 'classification/setError';
export const ADD_CLASSIFICATION_RESULT = 'classification/addResult';
export const CLEAR_CLASSIFICATION = 'classification/clear';
export const CLEAR_COMMUNITY_CLASSIFICATION = 'classification/clearCommunity';
export const SET_FILE_UPLOADING = 'classification/setFileUploading';

/**
 * Action creators
 */
export const setClassificationLoading = createAction<boolean>(SET_CLASSIFICATION_LOADING);
export const setClassificationError = createAction<DomainError[] | null>(SET_CLASSIFICATION_ERROR);
export const addClassificationResult = createAction<{
  communityId: string;
  result: ClassificationResult;
}>(ADD_CLASSIFICATION_RESULT);
export const clearClassification = createAction(CLEAR_CLASSIFICATION);
export const clearCommunityClassification = createAction<string>(CLEAR_COMMUNITY_CLASSIFICATION);
export const setFileUploading = createAction<boolean>(SET_FILE_UPLOADING);
